import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const SortOrderAtoZ = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M1.5 4c0-.28.22-.5.5-.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Zm0 4c0-.28.22-.5.5-.5h4.5a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Zm.5 3.5a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1H2Zm13.85-.93c.2.19.2.5 0 .7l-3 3.08a.5.5 0 0 1-.71 0l-3-3.08a.5.5 0 1 1 .71-.7l2.15 2.2V7a.5.5 0 1 1 1 0v5.77l2.14-2.2c.2-.2.51-.2.7 0Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default SortOrderAtoZ
